import React from 'react';
import PropTypes from 'prop-types';
import LikertQuestion from '../../LikertQuestion';
import LikertOptionsHeading from '../../LikertOptionsHeading';
import FreeQuestion from '../../FreeQuestion';
import SelectionQuestion from '../../SelectionQuestion';
import DropDownQuestion from '../../DropDownQuestion';
import StaticText from '../../StaticText';
import {
  questionTypeValues,
  schemaPartItemTypeValues,
  questionType,
  responseOptionType,
  SurveySchemaPartItemType
} from '../../../constants/types';

const QuestionItemPresentation = (
  {
    question,
    responseOptions,
    orderNum,
    getErrorState,
    handleResponseChange,
    getQuestionAnswer,
    lang,
    translate
  }
) => {
  const errorState = getErrorState(question);
  const answer = getQuestionAnswer(question);

  switch (question.type) {
    case questionTypeValues.LIKERT:
      return (
        <LikertQuestion
          question={question}
          orderNum={orderNum}
          onChange={handleResponseChange}
          responseOptions={responseOptions}
          lang={lang}
          key={question.id}
          errorState={errorState}
          answer={answer}
          translate={translate}
        />
      );
    case questionTypeValues.TEXT_FIELD:
      return (
        <FreeQuestion
          question={question}
          orderNum={orderNum}
          onChange={handleResponseChange}
          selectedLang={lang}
          key={question.id}
          errorState={errorState}
          answer={answer}
          translate={translate}
        />
      );
    case questionTypeValues.RADIO_BUTTON_GROUP:
    case questionTypeValues.CHECKBOX_GROUP:
      return (
        <SelectionQuestion
          question={question}
          orderNum={orderNum}
          onChange={handleResponseChange}
          responseOptions={responseOptions}
          lang={lang}
          key={question.id}
          errorState={errorState}
          answer={answer}
          translate={translate}
        />
      );
    case questionTypeValues.DROPDOWN:
      return (
        <DropDownQuestion
          question={question}
          orderNum={orderNum}
          onChange={handleResponseChange}
          responseOptions={responseOptions}
          lang={lang}
          key={question.id}
          errorState={errorState}
          answer={answer}
          translate={translate}
        />
      );
    default:
      return null;
  }
};

const getQuestionGroupSchemaPartItemPresentation = (surveyPartItemProps) => {
  const {
    schemaPartItem, lang, questionOrderNumById, handleResponseChange, getErrorState,
    getQuestionAnswer, translate
  } = surveyPartItemProps;
  const { questionGroup } = schemaPartItem;
  const { responseOptions } = questionGroup;
  const mainOptionsHeading = (
    <LikertOptionsHeading key="optionsHeading" responseOptions={responseOptions} lang={lang} />
  );

  const questions = [mainOptionsHeading, ...questionGroup.questions.map((question) => (
    <QuestionItemPresentation
      key={question.id}
      question={question}
      responseOptions={responseOptions}
      orderNum={questionOrderNumById[question.id]}
      handleResponseChange={handleResponseChange}
      getErrorState={getErrorState}
      getQuestionAnswer={getQuestionAnswer}
      translate={translate}
      lang={lang}
    />
  ))];
  return <div>{questions}</div>;
};

const SurveyPartItem = (props) => {
  switch (props.schemaPartItem.type) {
    case schemaPartItemTypeValues.STATIC_TEXT:
      return <StaticText staticText={props.schemaPartItem.staticText} lang={props.lang} />;
    case schemaPartItemTypeValues.QUESTION:
      return (
        <QuestionItemPresentation
          question={props.schemaPartItem.question}
          responseOptions={props.schemaPartItem.question.responseOptions}
          orderNum={props.questionOrderNumById[props.schemaPartItem.question.id]}
          handleResponseChange={props.handleResponseChange}
          getErrorState={props.getErrorState}
          translate={props.translate}
          getQuestionAnswer={props.getQuestionAnswer}
          lang={props.lang}
        />
      );
    case schemaPartItemTypeValues.QUESTION_GROUP:
      return getQuestionGroupSchemaPartItemPresentation(props);
    default:
      return null;
  }
};

const {
  func, number, string, arrayOf
} = PropTypes;

QuestionItemPresentation.propTypes = {
  question: questionType.isRequired,
  responseOptions: arrayOf(responseOptionType).isRequired,
  orderNum: number.isRequired,
  getErrorState: func.isRequired,
  handleResponseChange: func.isRequired,
  getQuestionAnswer: func.isRequired,
  translate: func.isRequired,
  lang: string.isRequired
};

SurveyPartItem.propTypes = {
  schemaPartItem: SurveySchemaPartItemType.isRequired,
  questionOrderNumById: arrayOf(number).isRequired,
  getErrorState: func.isRequired,
  handleResponseChange: func.isRequired,
  getQuestionAnswer: func.isRequired,
  translate: func.isRequired,
  lang: string.isRequired
};

export default SurveyPartItem;
